(() => {
  const initAccessories = (root) => {
    if (!root || root.dataset.accReady === 'true') return;
    root.dataset.accReady = 'true';

    const buttons = [...root.querySelectorAll('[data-acc-filter]')];
    const cards = [...root.querySelectorAll('[data-acc-model]')];
    const target = root.querySelector('[data-acc-products-target]');

    const applyFilter = (filter) => {
      buttons.forEach((button) => {
        const active = button.dataset.accFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      cards.forEach((card) => {
        const models = (card.dataset.accModel || '').split(/\s+/);
        card.hidden = filter !== 'all' && !models.includes(filter);
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.accFilter));
    });

    root.querySelectorAll('[data-acc-apply-filter]').forEach((card) => {
      const selectModel = () => {
        applyFilter(card.dataset.accApplyFilter);
        target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      card.addEventListener('click', selectModel);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectModel();
        }
      });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('.obp-accessories-v2').forEach(initAccessories);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
